<!--
  App shell. The AP Doc Viewer (default route) renders its own header/layout.
  The iframe guard avoids a reload during MSAL acquireTokenSilent() (hidden iframe).
  MSAL login/logout logic lives in app.component.ts (see 'CUSTOM CODE HERE').
-->
@if (!isIframe) {
  <router-outlet></router-outlet>
}
